import { render } from "./GameBudgetView.vue?vue&type=template&id=2f3fd796"
import script from "./GameBudgetView.vue?vue&type=script&lang=js"
export * from "./GameBudgetView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__